import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { read, utils } from "xlsx";
import * as XLSX from "xlsx";
import {
  Button,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  LinearProgress,
  Typography,
  Box,
} from "@material-ui/core";
import api from "../../services/api";
import { useHistory } from "react-router-dom";

import { CloudUpload as CloudUploadIcon, GetApp as GetAppIcon } from '@material-ui/icons';
import toastError from "../../errors/toastError";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { toast } from "react-toastify";

function WorksheetToDatagrid(ws) {
  /* create an array of arrays */
  const rows = utils.sheet_to_json(ws, { header: 1, defval: "" });

  /* create column array */
  const range = utils.decode_range(ws["!ref"] || "A1");
  const columns = Array.from({ length: range.e.c + 1 }, (_, i) => ({
    key: String(i), // RDG will access row["0"], row["1"], etc
    name: utils.encode_col(i), // the column labels will be A, B, etc
    //editor: textEditor // enable cell editing
  }));

  return { rows, columns }; // these can be fed to setRows / setColumns
}


const useStyles = makeStyles((theme) => ({
  xlsTable: {
    width: "100%",
  },
  tableContainer: {
    flex: 1,
    padding: theme.spacing(2),
    overflowX: "auto",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    backgroundColor: theme.palette.type === 'dark' ? '#252525' : "#fafafa",
    borderRadius: 8,
  },
  actions: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.type === 'dark' ? '#1e1e1e' : "#fff",
    borderRadius: 8,
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    border: "2px solid #2196f3",
  },
  importOptions: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.type === 'dark' ? '#1e1e1e' : "#fff",
    borderRadius: 6,
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  },
  error: {
    color: "#f44336",
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.type === 'dark' ? '#4a1919' : "#ffebee",
    borderRadius: 4,
    textAlign: "center",
  },
  buttonImport: {
    marginRight: theme.spacing(2),
    padding: theme.spacing(1, 3),
    fontSize: "0.95rem",
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
    },
  },
  select: {
    minWidth: 200,
    backgroundColor: theme.palette.type === 'dark' ? '#252525' : "#fff",
    borderRadius: 4,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2196f3",
      borderWidth: 2,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1976d2",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1565c0",
    },
  },
  backButtonContainer: {
    textAlign: "center",
    marginTop: theme.spacing(3),
  },
  uploadArea: {
    borderRadius: 12,
    maxWidth: 500,
    margin: "30px auto",
    border: "2px dashed #2196f3",
    padding: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#f5f9ff",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#1976d2",
      backgroundColor: "#e3f2fd",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(33, 150, 243, 0.2)",
    },
  },
  uploadIcon: {
    fontSize: 80,
    color: "#2196f3",
    marginBottom: theme.spacing(1),
  },
  uploadTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: "#1976d2",
    marginBottom: theme.spacing(0.5),
  },
  uploadSubtitle: {
    color: "#666",
    fontSize: "0.9rem",
    marginBottom: theme.spacing(1),
  },
  uploadNote: {
    color: "#f44336",
    fontWeight: 600,
    textAlign: "center",
    fontSize: "0.85rem",
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1),
    backgroundColor: "#ffebee",
    borderRadius: 6,
    maxWidth: 450,
  },
  successBox: {
    backgroundColor: "#e8f5e9",
    padding: theme.spacing(3),
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    border: "2px solid #4caf50",
  },
  successTitle: {
    color: "#2e7d32",
    fontSize: "1.2rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  successList: {
    listStyle: "none",
    padding: 0,
    "& li": {
      padding: theme.spacing(1),
      fontSize: "1rem",
      color: "#1b5e20",
      "&:before": {
        content: '"✓ "',
        color: "#4caf50",
        fontWeight: "bold",
        marginRight: theme.spacing(1),
      },
    },
  },
  tableHeader: {
    backgroundColor: "#2196f3",
    "& th": {
      color: "#fff",
      fontWeight: 600,
      fontSize: "0.95rem",
    },
  },
  selectRow: {
    backgroundColor: "#e3f2fd",
    borderTop: "2px solid #2196f3",
    borderBottom: "2px solid #2196f3",
    "& th": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      fontSize: "0.9rem",
      fontWeight: 500,
    },
  },
  progressBox: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#e3f2fd",
    borderRadius: 8,
  },
  progressText: {
    textAlign: "center",
    marginTop: theme.spacing(1),
    fontWeight: 600,
    color: "#1976d2",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  ignoredList: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.type === 'dark' ? '#3e2723' : "#fff3e0",
    borderRadius: 8,
    border: "2px solid #ff9800",
  },
  ignoredTitle: {
    color: "#e65100",
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
  },
  ignoredItem: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.type === 'dark' ? '#252525' : "#fff",
    borderRadius: 4,
    border: "1px solid #ffb74d",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  ignoredItemName: {
    fontWeight: 600,
    color: "#bf360c",
    fontSize: "0.95rem",
  },
  ignoredItemNumber: {
    color: "#666",
    fontSize: "0.9rem",
    marginTop: 2,
  },
  ignoredItemReason: {
    color: "#d84315",
    fontSize: "0.85rem",
    marginTop: 4,
    fontStyle: "italic",
  },
}));

const ContactImport = () => {
  const size = useWindowDimensions();

  const [rows, setRows] = useState(null);
  const [columns, setColumns] = useState(null);
  const classes = useStyles();
  const history = useHistory();
  const [contactFieldsAvailable, setContactFieldsAvailable] = useState([]);
  const [columnValue, setColumnValue] = useState({});
  const [selectedFields, setSelectedFields] = useState({}); // Para rastrear seleções únicas

  const [openingFile, setOpeningFile] = useState(false);
  const [selection, setSelection] = useState({});
  const [invalidFile, setInvalidFile] = useState(false);
  const [error, setError] = useState(null);
  const [countCreated, setCountCreated] = useState(0);
  const [countIgnored, setCountIgnored] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [imported, setImported] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const [validateContact, setValidateContact] = useState(false);
  
  // ✅ APENAS 2 CAMPOS: Nome e Número
  const contactFields = [
    { id: "name", label: "Nome", required: true },
    { id: "number", label: "Número", required: true },
  ];

  useEffect(() => {
    // Garantir que apenas Nome e Número estão disponíveis
    const fields = [
      { id: "name", label: "Nome", required: true },
      { id: "number", label: "Número", required: true },
    ];
    console.log("✅ Campos disponíveis para importação:", fields);
    setContactFieldsAvailable(fields);
  }, []);

  const [importTotal, setImportTotal] = useState(0);
  const [importProcessed, setImportProcessed] = useState(0);
  const [ignoredContacts, setIgnoredContacts] = useState([]); // Lista de contatos ignorados com motivo

  // Função para baixar modelo de exemplo
  const handleDownloadTemplate = () => {
    const templateData = [
      { nome: "João Silva", numero: "5511999999999" },
      { nome: "Maria Santos", numero: "5521988888888" },
      { nome: "Pedro Costa", numero: "5531977777777" },
    ];

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(templateData);
    XLSX.utils.book_append_sheet(wb, ws, "Contatos");
    XLSX.writeFile(wb, "modelo_importacao_contatos.xlsx");
    toast.success("Modelo baixado com sucesso!");
  };

  const processImport = async () => {
    setUploading(true);
    setCountCreated(0);
    setCountIgnored(0);
    setImportProcessed(0);
    setIgnoredContacts([]); // Limpar lista de ignorados

    const selectedIndexes = Object.keys(selectedRows).filter(k => selectedRows[k]);
    if (selectedIndexes.length === 0) {
      toastError("Nenhum contato selecionado");
      setUploading(false);
      return;
    }

    const totalToImport = selectedIndexes.length;
    setImportTotal(totalToImport);

    let created = 0;
    let ignored = 0;
    const ignoredList = [];

    if (rows?.length > 1) {
      for (let index = 1; index < rows.length; index++) {
        if (selectedRows[index]) {
          const item = rows[index];
          
          // ✅ MAPEAMENTO AUTOMÁTICO: Coluna 0 = Nome, Coluna 1 = Número
          const contactData = {
            name: item[0] || "",
            number: item[1] || "",
          };

          // Validar número: deve ter 10-15 dígitos
          if (contactData.number) {
            const digitsOnly = String(contactData.number).replace(/\D/g, "");
            if (digitsOnly.length < 10 || digitsOnly.length > 15) {
              ignored++;
              setCountIgnored(ignored);
              ignoredList.push({
                name: contactData.name,
                number: contactData.number,
                reason: `Número inválido (${digitsOnly.length} dígitos - precisa ter entre 10 e 15)`
              });
              setImportProcessed(prev => prev + 1);
              continue;
            }
          }

          // Verificar se os campos obrigatórios estão presentes
          if (!contactData.name || !contactData.number) {
            ignored++;
            setCountIgnored(ignored);
            ignoredList.push({
              name: contactData.name || "(sem nome)",
              number: contactData.number || "(sem número)",
              reason: "Nome ou número vazio"
            });
            setImportProcessed(prev => prev + 1);
            continue;
          }

          try {
            const data = await api.post('/contactsImport', {
              ...contactData,
              validateContact: validateContact ? "true" : "false",
            });

            if (data.status === 200) {
              created++;
              setCountCreated(created);
            } else {
              ignored++;
              setCountIgnored(ignored);
              ignoredList.push({
                name: contactData.name,
                number: contactData.number,
                reason: "Erro ao salvar no banco de dados"
              });
            }
          } catch (error) {
            ignored++;
            setCountIgnored(ignored);
            const errorMsg = error.response?.data?.error || error.message || "Erro desconhecido";
            ignoredList.push({
              name: contactData.name,
              number: contactData.number,
              reason: errorMsg
            });
          }

          setImportProcessed(prev => prev + 1);
        }
      }
      
      setIgnoredContacts(ignoredList); // Salvar lista de ignorados
      setValidateContact(false);
      setSelectedRows({});
      setImported(true);
      setUploading(false);
      
      if (ignored === 0) {
        toast.success("Importação realizada com sucesso");
      } else {
        toast.warn(`Importação concluída: ${created} importados, ${ignored} ignorados`);
      }
    }
  };

  const onChangeFile = (acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    setOpeningFile(true);
    setInvalidFile(false);
    setImported(false);
    setUploading(false);
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      try {
        const data = e.target.result;
        const wb = read(data);
        const ws = wb.Sheets[wb.SheetNames[0]];
        const { rows, columns } = WorksheetToDatagrid(ws);
        setRows(rows);
        setColumns(columns);
        setOpeningFile(false);
      } catch (e) {
        console.error(e);
        setInvalidFile(true);
        setOpeningFile(false);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    const columnKey = event.target.name;
  
    // Remover antiga seleção
    if (columnValue[columnKey]) {
      const oldValue = columnValue[columnKey];
      setSelectedFields((prevSelectedFields) => {
        const newSelectedFields = { ...prevSelectedFields };
        delete newSelectedFields[oldValue];
        return newSelectedFields;
      });
    }
  
    // Se o novo valor for vazio, limpar a seleção
    if (newValue === "") {
      setColumnValue((prevColumnValue) => {
        const newColumnValue = { ...prevColumnValue };
        delete newColumnValue[columnKey];
        return newColumnValue;
      });
      setSelection((prevSelection) => {
        const newSelection = { ...prevSelection };
        Object.keys(newSelection).forEach((key) => {
          if (newSelection[key] === columnKey) {
            delete newSelection[key];
          }
        });
        return newSelection;
      });
      return;
    }
  
    // Verificar se o novo valor já foi selecionado
    if (selectedFields[newValue]) {
      toastError(`O campo ${newValue} já foi selecionado.`);
      return;
    }
  
    // Atualizar seleção
    setSelection((selection) => ({ ...selection, [newValue]: columnKey }));
    setSelectedFields((prevSelectedFields) => ({ ...prevSelectedFields, [newValue]: columnKey }));
    setColumnValue((columnValue) => ({ ...columnValue, [columnKey]: newValue }));
  };
  

  const renderSelectbox = (column) => {
    return (
      <Select 
        value={columnValue[column.key]} 
        name={column.key} 
        onChange={handleSelectChange}
        className={classes.select}
        variant="outlined"
      >
        <MenuItem value="">
          <em style={{ color: "#999" }}>Selecione um campo</em>
        </MenuItem>
        {contactFieldsAvailable.map((contactField) => (
          <MenuItem 
            key={contactField.id} 
            value={contactField.id}
            style={{ fontWeight: contactField.required ? 600 : 400 }}
          >
            {contactField.label} {contactField.required && <span style={{ color: "#f44336" }}>*</span>}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const renderXls = () => {
    return (
      <TableContainer className={classes.tableContainer} style={{ height: size.height * 0.75 }}>
        <Table stickyHeader>
          <TableHead key={columns.length}>
            <TableRow className={classes.tableHeader}>
              <TableCell>
                <input
                  type="checkbox"
                  checked={Object.keys(selectedRows).length === rows.length - 1}
                  onChange={(event) => {
                    const isChecked = event.target.checked;
                    const newSelectedRows = {};
                    if (isChecked) {
                      for (let i = 1; i < rows.length; i++) {
                        newSelectedRows[i] = true;
                      }
                    }
                    setSelectedRows(newSelectedRows);
                  }}
                  style={{ cursor: "pointer", transform: "scale(1.2)" }}
                />
              </TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Número</TableCell>
              {columns.slice(2).map((column) => (
                <TableCell key={column.key}>{column.name}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow 
                key={rowIndex}
                style={{
                  backgroundColor: rowIndex % 2 === 0 ? "#fff" : "#fafafa",
                }}
              >
                {rowIndex !== 0 && (
                  <>
                    <TableCell>
                      <input
                        type="checkbox"
                        checked={!!selectedRows[rowIndex]}
                        onChange={() => {
                          setSelectedRows((prevSelectedRows) => ({
                            ...prevSelectedRows,
                            [rowIndex]: !prevSelectedRows[rowIndex],
                          }));
                        }}
                        style={{ cursor: "pointer", transform: "scale(1.2)" }}
                      />
                    </TableCell>
                    {row.map((column, columnIndex) => (
                      <TableCell key={columnIndex}>{column}</TableCell>
                    ))}
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };


  const handleCloseImport = async () => {
    try {
      history.push("/contacts");
    } catch (err) {
      toastError(err);
    }
  };

  const renderContent = () => {
    return (
      <div>
        <div className={classes.importOptions}>
          <Typography variant="subtitle1" style={{ marginBottom: 12, color: "#1976d2", fontWeight: 600 }}>
            Opções de Importação
          </Typography>
          <FormGroup row style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
            <FormControlLabel
              control={
                <Switch 
                  checked={validateContact} 
                  onChange={(event) => setValidateContact(event.target.checked)} 
                  color="primary" 
                />
              }
              label={
                <span style={{ fontSize: "0.9rem" }}>
                  Validar contatos no WhatsApp 
                  <Typography variant="caption" display="block" style={{ color: "#666", fontSize: "0.8rem" }}>
                    (Verifica se o número existe no WhatsApp antes de importar)
                  </Typography>
                </span>
              }
            />
          </FormGroup>
        </div>

        {/* Instruções simplificadas */}
        <Box 
          style={{ 
            padding: 12, 
            backgroundColor: "#e8f5e9", 
            borderRadius: 6, 
            marginBottom: 12,
            border: "2px solid #4caf50"
          }}
        >
          <Typography variant="body2" style={{ fontWeight: 600, color: "#2e7d32", marginBottom: 6 }}>
            ℹ️ Formato do arquivo:
          </Typography>
          <Typography variant="body2" style={{ color: "#1b5e20", fontSize: "0.9rem" }}>
            • <strong>1ª coluna:</strong> Nome do contato
          </Typography>
          <Typography variant="body2" style={{ color: "#1b5e20", fontSize: "0.9rem" }}>
            • <strong>2ª coluna:</strong> Número do contato (10-15 dígitos)
          </Typography>
        </Box>

        {/* ✅ BOTÕES NO TOPO - SEMPRE VISÍVEIS */}
        <div className={classes.actions} style={{ marginTop: 0, marginBottom: 16 }}>
          {uploading && (
            <Box className={classes.progressBox}>
              <LinearProgress
                variant="determinate"
                value={importTotal > 0 ? Math.round((importProcessed / importTotal) * 100) : 0}
                style={{ height: 8, borderRadius: 4 }}
              />
              <Typography variant="body1" className={classes.progressText}>
                {importProcessed} de {importTotal} contatos processados ({importTotal > 0 ? Math.round((importProcessed / importTotal) * 100) : 0}%)
              </Typography>
              {countCreated > 0 && (
                <Typography variant="body2" style={{ textAlign: "center", color: "#4caf50", marginTop: 4 }}>
                  ✓ {countCreated} importados
                </Typography>
              )}
              {countIgnored > 0 && (
                <Typography variant="body2" style={{ textAlign: "center", color: "#ff9800", marginTop: 4 }}>
                  ⚠ {countIgnored} ignorados
                </Typography>
              )}
            </Box>
          )}
          <div className={classes.buttonGroup}>
            <Button
              variant="contained"
              color="primary"
              disabled={uploading}
              className={classes.buttonImport}
              onClick={() => processImport()}
              style={{ textTransform: "none" }}
            >
              {uploading ? "Importando..." : "Importar Contatos"}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              disabled={uploading}
              onClick={() => {
                setRows(null);
                setColumns(null);
              }}
              style={{ textTransform: "none", padding: "8px 24px" }}
            >
              Cancelar
            </Button>
          </div>
          {error && <div className={classes.error}>{error}</div>}
        </div>

        {renderXls()}
      </div>
    );
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onChangeFile,
    maxFiles: 1,
  });

  return (
    <div style={{ alignContent: "center" }}>
      {imported && (
        <div>
          <div className={classes.successBox}>
            <div className={classes.successTitle}>
              ✓ Importação Concluída!
            </div>
            <ul className={classes.successList}>
              <li>{countCreated} contatos importados</li>
              <li>{countIgnored} contatos ignorados</li>
            </ul>
            <div className={classes.backButtonContainer}>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={handleCloseImport}
                style={{ 
                  padding: "10px 24px",
                  textTransform: "none",
                  fontSize: "0.9rem",
                  fontWeight: 600,
                }}
              >
                Ir para Lista de Contatos
              </Button>
            </div>
          </div>

          {/* ✅ LISTA DE CONTATOS IGNORADOS */}
          {ignoredContacts.length > 0 && (
            <div className={classes.ignoredList}>
              <div className={classes.ignoredTitle}>
                ⚠️ Contatos Ignorados ({ignoredContacts.length})
              </div>
              <Typography variant="body2" style={{ color: "#bf360c", marginBottom: 12 }}>
                Os seguintes contatos não foram importados. Corrija os erros e tente novamente:
              </Typography>
              <div style={{ maxHeight: 400, overflowY: "auto" }}>
                {ignoredContacts.map((contact, index) => (
                  <div key={index} className={classes.ignoredItem}>
                    <div className={classes.ignoredItemName}>
                      {contact.name}
                    </div>
                    <div className={classes.ignoredItemNumber}>
                      Número: {contact.number}
                    </div>
                    <div className={classes.ignoredItemReason}>
                      Motivo: {contact.reason}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {openingFile && <div>Processando arquivo...</div>}
      {invalidFile && <div>Arquivo inválido!</div>}
      {!imported && rows && columns ? renderContent() : (
        <>
          <div
            {...getRootProps()}
            className={classes.uploadArea}
          >
            <CloudUploadIcon className={classes.uploadIcon} />
            <div className={classes.uploadTitle}>
              Importar Contatos
            </div>
            <div className={classes.uploadSubtitle}>
              Clique ou arraste um arquivo aqui
            </div>
            <Typography variant="body2" style={{ color: "#999", marginTop: 8 }}>
              Formatos aceitos: XLSX, XLS, CSV, TXT
            </Typography>
            <div className={classes.uploadNote}>
              ⚠️ O arquivo deve conter as colunas: <strong>Nome</strong> e <strong>Número</strong>
            </div>
          </div>

          <input {...getInputProps()} />

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<GetAppIcon />}
              onClick={handleDownloadTemplate}
              style={{
                padding: "10px 24px",
                textTransform: "none",
                fontSize: "0.9rem",
                fontWeight: 600,
                borderWidth: 2,
              }}
            >
              Baixar Modelo de Exemplo
            </Button>
          </div>

          <div className={classes.backButtonContainer}>
            <Button 
              variant="outlined" 
              color="primary" 
              disabled={uploading} 
              onClick={handleCloseImport}
              style={{ 
                padding: "10px 24px",
                textTransform: "none",
                fontSize: "0.9rem",
                fontWeight: 600,
              }}
            >
              ← Voltar para Contatos
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ContactImport;
